export const isStringSinglePoint = stringPoint => {
    if (/^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(stringPoint)) {
        return true;
    }
    return false;
};
